import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
export default {
  name: 'JEllipsis',
  props: {
    value: {
      type: String,
      required: false
    },
    length: {
      type: Number,
      required: false,
      default: 25
    }
  }
};